import * as React from 'react';

export const IconFunctionalHelpCircle16 = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill='var(--surface-main-default)'
      />
      <path
        d="M8.0502 13C7.4502 13 7.0502 12.6 7.0502 12C7.0502 11.4 7.4502 11 8.0502 11C8.6502 11 9.0502 11.4 9.0502 12C9.0502 12.6 8.6502 13 8.0502 13ZM9.5502 8.4C9.0502 8.7 9.0502 8.8 9.0502 9V10H7.0502V9C7.0502 7.7 7.85019 7.1 8.45019 6.7C8.95019 6.4 9.0502 6.3 9.0502 6C9.0502 5.4 8.6502 5 8.0502 5C7.6502 5 7.3502 5.2 7.1502 5.5L6.6502 6.4L4.9502 5.4L5.4502 4.5C5.9502 3.6 6.9502 3 8.0502 3C9.7502 3 11.0502 4.3 11.0502 6C11.0502 7.4 10.1502 8 9.5502 8.4Z"
        fill='var(--accent-main-primary)'
      />
    </svg>
  );
};
